import script from "./ServiceTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceTable.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceTable.vue?vue&type=style&index=0&id=0446347c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0446347c"]])

export default __exports__